exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Spacer_spacer__2KpGy {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex: 1 1;\n          flex: 1 1; }\n", ""]);

// exports
exports.locals = {
	"spacer": "Spacer_spacer__2KpGy"
};